var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * MUI keeps most boxShadows in shadow theme property.
 * Elevations applies for Paper based elements.
 *
 * usage example: boxShadow: 1;
 */
var designSystemElevations = {
    Elevation1: '0px 2px 15px rgba(0, 0, 0, 0.15)',
    Elevation4: '0px 40px 100px rgba(0, 0, 0, 0.1)',
    Elevation5: '0px 0px 16px rgba(0, 0, 0, 0.15)',
    Elevation6: '0px 2px 10px rgba(0, 0, 0, 0.25)',
    Elevation7: '0px 2px 2px rgba(0, 0, 0, 0.1), 0px 5px 25px rgba(0, 0, 0, 0.15)',
};
export var shadows = __spreadArray([
    'none',
    designSystemElevations.Elevation1,
    'none',
    'none',
    designSystemElevations.Elevation4,
    designSystemElevations.Elevation5,
    designSystemElevations.Elevation6,
    designSystemElevations.Elevation7
], Array(18).fill('none'), true);
